import React from 'react'
import type { ContextProps } from './Context'
import { Provider } from './Context'
import { Layout } from './Layout'

export const ChangePassword = (props: ContextProps) => {
  return (
    <Provider {...props}>
      <Layout />
    </Provider>
  )
}
